import {Component, Input} from '@angular/core';
import {UserAttribute} from "../../../../../model/user-attribute";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'attribute-agreement',
  templateUrl: './attribute-agreement.component.html',
  styleUrls: ['./attribute-agreement.component.scss']
})
export class AttributeAgreementComponent {
  @Input() attribute: UserAttribute;
  @Input() form: FormGroup
  @Input() disabled: boolean
  @Input() readonly: boolean
  value: string;
}
